import operlogEdit from './edit.vue'
import operlogList from './list.vue'
import * as logininfor from './logininfor'

let a = Object.assign({ operlogEdit, operlogList},logininfor)
export default a
